import keyBy from 'lodash/keyBy';
import { IMarketStat, IMarketStatView } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketStat';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import { IProduct } from '@/creditflowresearch/domain/vo/Product';
import { IMarketCategory } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Stats/IMarketCategory';
import Market from '@/creditflowresearch/domain/Market';

export const getStatsDataForView = (
  data: IMarketStat[],
  mapCategories: Record<string, IMarketCategory>,
  regionsList: IRegion[],
  productsList: IProduct[],
): IMarketStatView[] => {
  const regionMap = keyBy(regionsList, 'id');
  const productMap = keyBy(productsList, 'id');

  return data.map((item) => {
    const categories = item.categories
      .map((category) => mapCategories[category])
      .filter((category): category is IMarketCategory => Boolean(category));

    const regionIds = [...new Set(
      categories
        .map((category) => category?.regionId)
        .filter((regionId): regionId is string => Boolean(regionId)),
    )];
    const productIds = [...new Set(
      categories
        .map((category) => category?.productId)
        .filter((productId): productId is string => Boolean(productId)),
    )];

    const regions = regionIds
      .map((regionId) => regionMap[regionId]?.abbreviation)
      .filter((abbreviation): abbreviation is string => Boolean(abbreviation))
      .sort();
    const products = productIds
      .map((productId) => productMap[productId]?.abbreviation)
      .filter((abbreviation): abbreviation is string => Boolean(abbreviation))
      .sort();

    const markets = [...new Set(
      categories.map((c) => Market.getAbbreviation(c.marketId))
        .filter((abbreviation: string): abbreviation is string => Boolean(abbreviation))
        .sort(),
    )];

    return {
      ...item,
      categoriesNames: [...new Set(
        categories
          .map((category) => category?.name)
          .filter((name): name is string => Boolean(name))
          .sort(),
      )],
      regions,
      regionIds,
      products,
      markets,
    };
  });
};
